<template>
  <div class="pb-5 pt-0">
    <v-img alt="" contain class="page-header" src="@/assets/redcar/page-headers/vips.png" />

    <v-card class="px-3 py-3 items-wrapper">
      <p v-if="!all_vips.length" v-html="translations.viplist.labels.text"></p>

      <v-list class="px-0" subheader>

        <v-list-item
          v-for="vip in all_vips"
          :key=   "vip.id"
          class="px-0 vip"
        >
          <v-list-item-avatar>
            <v-img
              v-if='vip.image'
              :alt="`${vip.title} avatar`"
              :src="vip.image"
            ></v-img>
            <v-icon v-else :color="'primary accent-4'">
              mdi-account
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title >{{vip.first_name}} {{vip.surname}}</v-list-item-title>
          </v-list-item-content>

          <a v-if="vip.phone !== ''" :href="'tel:' + vip.phone" class="phone pa-3" @click="handleContentClick($event)"><span class="sr-only">Call {{vip.phone}}</span></a>
          <a v-if="vip.email !== ''" :href="'mailto:' + vip.email" class="email pa-3"  @click="handleContentClick($event)"><span class="sr-only">Email {{vip.email}}</span></a>

          <v-list-item-icon class="pa-1 mt-4" >
            <button @click="openEditingOverlay(vip)">
              <v-icon :color="'red accent-4'" style="height: 26px; width:26px">
                mdi-border-color
              </v-icon>
              <span class="sr-only">Delete VIP</span>
            </button>
          </v-list-item-icon>
        </v-list-item>
      </v-list>

      <v-dialog v-model="overlay" width="400" dark>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" class="white--text text-capitalize mr-2" v-bind="attrs" v-on="on">
            {{ translations.viplist.labels.button }}
            <v-icon right>
              mdi-open-in-new
            </v-icon>
          </v-btn>
        </template>

        <VipForm
          v-if="overlay"
          @overlay="closeOverlay"
          :editingVip="selectedVip"
        />
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import vips from "@/vips";
import VipForm from '@/components/Vips/VipForm.vue';
import hubbdata from "@/hubbdata";

export default {
  name: 'Vips',
  props: {
    editingVip: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      overlay: false,
      selectedVip: {}
    }
  },
  components: {
    VipForm
  },
  computed: {
    all_vips() {
      return vips.state.vips;
    },
    translations() {
       return hubbdata.getters.translations;
    },
  },
  methods: {
    closeOverlay() {
      this.overlay = false
      this.selectedVip = {}
    },
    openEditingOverlay(vip) {
      this.selectedVip = vip
      this.overlay = true
    },
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}

.v-card {
  box-shadow:  0px 0px 0px 0px!important;
}

.vip {

  .phone::before {
    content:"";
    background-image: url('../assets/redcar/phone.png'); /* with class ModalCarrot ??*/
    background-size: 25px 25px;
    display: inline-block;
    width: 25px;
    height: 25px;
    margin-top: 5px;
  }

  .email::before {
    content:"";
    background-image: url('../assets/redcar/email.png'); /* with class ModalCarrot ??*/
    background-size: 25px 25px;
    display: inline-block;
    width: 25px;
    height: 25px;
    margin-top: 5px;
  }

  .v-list-item__icon {
    margin-right: 0px !important;
  }
}

.v-overlay * {
  color: white !important;
}

.v-btn--contained {

  @media screen and (min-width: 960px) {
    font-size: 16px !important;
  }
}
</style>